<template>
<div class="chapter">
<div class="inner_page">
<div class="group">
<p class="C579"><span class="size_235"><strong><span id="page_12">DESIGN</span> PRINCIPLES</strong></span></p>
<p class="C572"><img alt="" src="img/13_1.jpg"/></p>
</div>
<div class="group">
<p class="C583"><span class="size_155"><span id="page_13">Unity</span> in design is the overarching important element.</span></p>
<p class="C580">When thinking about design, whether it’s graphic design, website design, interior design, fabric design, or quilt design, keep in mind several important elements: space, proportion, pattern, texture, line, shape, balance, and color.</p>
<p class="C580">Unity in design is the overarching important element. Without unity you can end up with a chaotic, even ugly, design, but you need variety too. Without variety, your design can be boring and stale. Balance is the key—getting the elements in proportion and adding enough points of interest and contrast to create a dynamic, visually exciting design. When all of your design elements seem to really <em>work</em>, this is called <em>gestalt</em>—a German design term that describes that elusive perfection of when a design seems to come together perfectly. Gestalt is achieved through the control of all the design elements.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 08_Design_P.vue?c0b08cae